import { api } from '../../../lib/api'

export const ADD_REAL_ESTATE_PRODUCT_DATA_REQUEST = 'ADD_REAL_ESTATE_PRODUCT_DATA_REQUEST'
export const ADD_REAL_ESTATE_PRODUCT_DATA_SUCCESS = 'ADD_REAL_ESTATE_PRODUCT_DATA_SUCCESS'
export const ADD_REAL_ESTATE_PRODUCT_DATA_FAILED = 'ADD_REAL_ESTATE_PRODUCT_DATA_FAILED'
export const REAL_ESTATE_CLEAR_ADD_PRODUCT = 'REAL_ESTATE_CLEAR_ADD_PRODUCT'

export const ADD_REAL_ESTATE_TEXTURES_SUCCESS = 'ADD_REAL_ESTATE_TEXTURES_SUCCESS'
export const ADD_REAL_ESTATE_TEXTURES_FAILED = 'ADD_REAL_ESTATE_TEXTURES_FAILED'

export const addRealEstateProductData = function (productData, productId) {
  return function (dispatch) {

    dispatch({
      type: ADD_REAL_ESTATE_PRODUCT_DATA_REQUEST
    })

    api.addRealEstateProductData(productData, productId).then(addRealEstateProductDataResponse => {
      dispatch({
        type: ADD_REAL_ESTATE_PRODUCT_DATA_SUCCESS,
        payload: addRealEstateProductDataResponse
      })
    }).catch(error => {
      dispatch({
        type: ADD_REAL_ESTATE_PRODUCT_DATA_FAILED,
        error
      })
    })
  }
}

export const clearRealEstateAddProduct = function () {
  return function (dispatch) {
    dispatch({
      type: REAL_ESTATE_CLEAR_ADD_PRODUCT
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/add-real-estate-product-data.js